import * as React from 'react';
import { useRouter } from '@tanstack/react-router';

/**
 * Announces route changes to assistive technology via a live region.
 */
export function RouteAnnouncer() {
  const router = useRouter();
  const [message, setMessage] = React.useState('');
  const lastPathRef = React.useRef('');

  React.useEffect(() => {
    const unsubscribe = router.subscribe('onLoad', ({ pathChanged }) => {
      if (!pathChanged) return;
      const pathname =
        typeof window !== 'undefined' ? window.location.pathname : '';
      if (pathname === lastPathRef.current) return;
      lastPathRef.current = pathname;
      setMessage(`Navegado a ${pathname}`);
    });
    return () => unsubscribe();
  }, [router]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
